import LineChart from 'components/report-content/components/line-chart/LineChart';
import LineChartEditPanel from 'components/report-content/components/line-chart/LineChartEditPanel';
import React from 'react';
import { AbstractComponentBuilder, ComponentSettingsLineChart } from '@report-content';

export default class LineChartComponentBuilder extends AbstractComponentBuilder<ComponentSettingsLineChart> {
    getComponent() {
        return (
            <LineChart
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <LineChartEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
